<template>
  <div>
    <Chart :cdata="config" />
  </div>
</template>

<script>
import Chart from "./chart.vue";
export default {
  props: {
    cdata: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    cdata(newVal) {
      console.log("newVal", newVal);
      if (newVal.length) {
        this.setData(newVal);
      }
    },
  },
  data() {
    return {
      config: {},
    };
  },
  components: {
    Chart,
  },
  mounted() {
    // console.log("chartTwoChart", this.cdata);
    // this.setData();
  },
  methods: {
    // 根据自己的业务情况修改
    setData(data) {
      let category = [];
      let series1 = [];
      let series2 = [];
      let series3 = [];
      let series4 = [];
      data.forEach((p, i) => {
        if (i == 0) {
          for (let item in p) {
            category.push(item);
            series1.push(p[item][0]);
            series2.push(p[item][1]);
          }
        } else {
          for (let item in p) {
            series3.push(p[item][0]);
            series4.push(p[item][1]);
          }
        }
      });

      this.config = {
        category,
        series1,
        series2,
        series3,
        series4,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
